function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import DebugLogger from "debug";
import { Observable } from "observable-fns";
import { deserialize } from "../common";
import { createPromiseWithResolver } from "../promise";
import { $errors, $events, $terminate, $worker } from "../symbols";
import { WorkerEventType } from "../types/master";
import { createProxyFunction, createProxyModule } from "./invocation-proxy";
var debugMessages = DebugLogger("threads:master:messages");
var debugSpawn = DebugLogger("threads:master:spawn");
var debugThreadUtils = DebugLogger("threads:master:thread-utils");

var isInitMessage = function isInitMessage(data) {
  return data && data.type === "init";
};

var isUncaughtErrorMessage = function isUncaughtErrorMessage(data) {
  return data && data.type === "uncaughtError";
};

var initMessageTimeout = typeof process !== "undefined" && process.env.THREADS_WORKER_INIT_TIMEOUT ? Number.parseInt(process.env.THREADS_WORKER_INIT_TIMEOUT, 10) : 10000;

function withTimeout(promise, timeoutInMs, errorMessage) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var timeoutHandle, timeout, result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            timeout = new Promise(function (resolve, reject) {
              timeoutHandle = setTimeout(function () {
                return reject(Error(errorMessage));
              }, timeoutInMs);
            });
            _context.next = 3;
            return Promise.race([promise, timeout]);

          case 3:
            result = _context.sent;
            clearTimeout(timeoutHandle);
            return _context.abrupt("return", result);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}

function receiveInitMessage(worker) {
  return new Promise(function (resolve, reject) {
    var messageHandler = function messageHandler(event) {
      debugMessages("Message from worker before finishing initialization:", event.data);

      if (isInitMessage(event.data)) {
        worker.removeEventListener("message", messageHandler);
        resolve(event.data);
      } else if (isUncaughtErrorMessage(event.data)) {
        worker.removeEventListener("message", messageHandler);
        reject(deserialize(event.data.error));
      }
    };

    worker.addEventListener("message", messageHandler);
  });
}

function createEventObservable(worker, workerTermination) {
  return new Observable(function (observer) {
    var messageHandler = function messageHandler(messageEvent) {
      var workerEvent = {
        type: WorkerEventType.message,
        data: messageEvent.data
      };
      observer.next(workerEvent);
    };

    var rejectionHandler = function rejectionHandler(errorEvent) {
      debugThreadUtils("Unhandled promise rejection event in thread:", errorEvent);
      var workerEvent = {
        type: WorkerEventType.internalError,
        error: Error(errorEvent.reason)
      };
      observer.next(workerEvent);
    };

    worker.addEventListener("message", messageHandler);
    worker.addEventListener("unhandledrejection", rejectionHandler);
    workerTermination.then(function () {
      var terminationEvent = {
        type: WorkerEventType.termination
      };
      worker.removeEventListener("message", messageHandler);
      worker.removeEventListener("unhandledrejection", rejectionHandler);
      observer.next(terminationEvent);
      observer.complete();
    });
  });
}

function createTerminator(worker) {
  var _this = this;

  var _createPromiseWithRes = createPromiseWithResolver(),
      _createPromiseWithRes2 = _slicedToArray(_createPromiseWithRes, 2),
      termination = _createPromiseWithRes2[0],
      resolver = _createPromiseWithRes2[1];

  var terminate = function terminate() {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              debugThreadUtils("Terminating worker"); // Newer versions of worker_threads workers return a promise

              _context2.next = 3;
              return worker.terminate();

            case 3:
              resolver();

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
  };

  return {
    terminate: terminate,
    termination: termination
  };
}

function setPrivateThreadProps(raw, worker, workerEvents, terminate) {
  var _Object$assign;

  var workerErrors = workerEvents.filter(function (event) {
    return event.type === WorkerEventType.internalError;
  }).map(function (errorEvent) {
    return errorEvent.error;
  }); // tslint:disable-next-line prefer-object-spread

  return Object.assign(raw, (_Object$assign = {}, _defineProperty(_Object$assign, $errors, workerErrors), _defineProperty(_Object$assign, $events, workerEvents), _defineProperty(_Object$assign, $terminate, terminate), _defineProperty(_Object$assign, $worker, worker), _Object$assign));
}
/**
 * Spawn a new thread. Takes a fresh worker instance, wraps it in a thin
 * abstraction layer to provide the transparent API and verifies that
 * the worker has initialized successfully.
 *
 * @param worker Instance of `Worker`. Either a web worker, `worker_threads` worker or `tiny-worker` worker.
 * @param [options]
 * @param [options.timeout] Init message timeout. Default: 10000 or set by environment variable.
 */


export function spawn(worker, options) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var timeout, initMessage, exposed, _createTerminator, termination, terminate, events, proxy, _proxy, type;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            debugSpawn("Initializing new thread");
            timeout = options && options.timeout ? options.timeout : initMessageTimeout;
            _context3.next = 4;
            return withTimeout(receiveInitMessage(worker), timeout, "Timeout: Did not receive an init message from worker after ".concat(timeout, "ms. Make sure the worker calls expose()."));

          case 4:
            initMessage = _context3.sent;
            exposed = initMessage.exposed;
            _createTerminator = createTerminator(worker), termination = _createTerminator.termination, terminate = _createTerminator.terminate;
            events = createEventObservable(worker, termination);

            if (!(exposed.type === "function")) {
              _context3.next = 13;
              break;
            }

            proxy = createProxyFunction(worker);
            return _context3.abrupt("return", setPrivateThreadProps(proxy, worker, events, terminate));

          case 13:
            if (!(exposed.type === "module")) {
              _context3.next = 18;
              break;
            }

            _proxy = createProxyModule(worker, exposed.methods);
            return _context3.abrupt("return", setPrivateThreadProps(_proxy, worker, events, terminate));

          case 18:
            type = exposed.type;
            throw Error("Worker init message states unexpected type of expose(): ".concat(type));

          case 20:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
}